import { defineStore } from 'pinia';

const query = {
    search: '',
    type: ['Consumer', 'Agent', 'NonListing']
};

export const usePromotionStore = defineStore('promotion', {
    state: () => {
        return {
            query: {...query},
            page: 1
        }
    },
    getters: {
        hasFilters() {
            return JSON.stringify(this.query) != JSON.stringify(query)
        }
    },
    actions: {
        setPage(page) {
            if(typeof page == 'number') {
                this.page = page;
                return;
            }
            if(page == 'next') {
                this.page++;
            } else {
                this.page--;
            }
        },
        clear() {
            this.query = {...query}
        }
    }
})
